import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

const initSentry = () => {
  try {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      maxBreadcrumbs: 50,
      // Alternatively, use `process.env.npm_package_version` for a dynamic release version
      // if your build tool supports it.
      release: process.env.SENTRY_RELEASE,
      integrations: [new BrowserTracing(),
        new Sentry.Integrations.Breadcrumbs({
          console: true,
          dom: true,
          fetch: true,
          history: true,
          xhr: true
        })
      ],
      environment: process.env.SENTRY_ENVIRONMENT,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: process.env.SENTRY_TRACE_SAMPLE_RATE,
      attachStacktrace: true,
      sampleRate: process.env.SENTRY_SAMPLE_RATE

    });
  } catch (error) {
    console.error('Sentry initialization failed:', error);
  }
};

export default initSentry;
